export enum WebhookEventTypeEnum {
    campaignActivated,
    campaignPaused,
    campaignCompleted,
    memberAdded,
    memberStatusChanged,
    memberConverted,
    memberRemoved,
    refreshCompleted,
    refreshFailed
}
